/* global dataLayer */
import humps from 'humps'
import { takeEvery, all, put, call, select } from 'redux-saga/effects'

import request from 'utils/request'
import getApiUrl from 'utils/getApiUrl'
import {
  FETCH_RESULT, FETCH_RESULT_SUCCESS, fetchResultsSuccess, fetchResultsFailure
} from './actions'
import { selectAnswers } from './selectors'
import { createTasteProfileEvent } from 'utils/tagManager'

const showSaveTasteProfilePopup = () => {
  if (document.querySelector('body[data-test-200]')) {
    return
  }
  // dispatch custom event to `tasteprofile` Backbone component to show the popup
  const event = document.createEvent('Event')
  event.initEvent('saveTasteProfile', true, true)
  window.dispatchEvent(event)
}

export function * fetchAndWait () {
  // Get results from fetchResults, but wait at least 2 seconds before putting the action
  const [results] = yield all([
    call(fetchResults)
  ])
  yield put(results)
  yield call(showSaveTasteProfilePopup)
}

export function * fetchResults () {
  const url = getApiUrl('/smaakprofielen/profile.json')
  const method = 'post'
  const data = yield select(selectAnswers)

  try {
    const result = yield call(request, {url, method, data})
    return fetchResultsSuccess(humps.camelizeKeys(result))
  } catch (err) {
    console.error(err)
    return fetchResultsFailure()
  }
}

export function * watchFetchResults () {
  yield takeEvery(FETCH_RESULT, fetchAndWait)
}

export function * pushAnalyticsEvents (action) {
  const colors = {
    1: 'Rood',
    2: 'Wit'
  }
  yield call(() => {
    action.result.tasteProfiles.forEach((tasteProfile) => {
      dataLayer.push(
        createTasteProfileEvent(
          'Afgerond',
          `${colors[tasteProfile.color]} - ${tasteProfile.name}`,
          true
        )
      )
    })
  })
}

export function * watchFetchResultsSuccess () {
  yield takeEvery(FETCH_RESULT_SUCCESS, pushAnalyticsEvents)
}

export default [
  watchFetchResults,
  watchFetchResultsSuccess
]
